const decodeSpl = (str) => {
  const decodedStr = str.replaceAll("@", "&").replaceAll("*", "=");
  return decodedStr;
};

export default decodeSpl;
